/* Hover-to-open for desktop mega menus + live review on 2-second card hover.
   Click/keyboard behavior stays Dawn's native details/summary disclosure;
   this only adds pointer affordance on hover-capable, fine-pointer devices. */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var REVIEW_API   = 'https://api.reviewugc.neurogan.com/api/v1/reviews/';
  var REVIEW_BRAND = 'Neurogan_Pets';
  var reviewCache  = Object.create(null); // handle -> review object | null

  /* ---- utilities ---- */

  function timeAgo(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    var diff = Math.floor((Date.now() - d) / 1000);
    if (diff < 60)          return 'just now';
    if (diff < 3600)        return Math.floor(diff / 60) + 'm ago';
    if (diff < 86400)       return Math.floor(diff / 3600) + 'h ago';
    if (diff < 86400 * 7)   return Math.floor(diff / 86400) + 'd ago';
    if (diff < 86400 * 30)  return Math.floor(diff / (86400 * 7)) + 'w ago';
    if (diff < 86400 * 365) return Math.floor(diff / (86400 * 30)) + 'mo ago';
    return Math.floor(diff / (86400 * 365)) + 'y ago';
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function starStr(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆';
    return s;
  }

  /* ---- review render ---- */
  /* API fields: reviewerDisplayName, publishedAt, verifiedBuyer (0|1) */

  function renderReview(review, container) {
    var body     = (review.body || '').trim();
    if (body.length > 130) body = body.slice(0, 127) + '…';
    var ago      = timeAgo(review.publishedAt);
    var author   = review.reviewerDisplayName || '';
    var verified = review.verifiedBuyer === 1;

    container.innerHTML =
      '<div class="mega-menu__live-review-inner">' +
        '<div class="mega-menu__live-review-tag">' +
          '<span class="mega-menu__live-review-tag-stars">' + starStr(review.rating) + '</span>' +
          (ago ? '<span class="mega-menu__live-review-tag-ago">' + escHtml(ago) + '</span>' : '') +
        '</div>' +
        '<div class="mega-menu__live-review-body">' +
          (review.title ? '<p class="mega-menu__live-review-title">' + escHtml(review.title) + '</p>' : '') +
          '<p class="mega-menu__live-review-text">“' + escHtml(body) + '”</p>' +
          '<div class="mega-menu__live-review-footer">' +
            (author ? '<span>— ' + escHtml(author) + '</span>' : '') +
            (verified ? '<span class="mega-menu__live-review-badge">✓ Verified buyer</span>' : '') +
          '</div>' +
        '</div>' +
      '</div>';

    // Re-trigger keyframe if re-rendering for a different product
    var inner = container.querySelector('.mega-menu__live-review-inner');
    if (inner) { inner.style.animation = 'none'; void inner.offsetWidth; inner.style.animation = ''; }
    container.classList.add('is-visible');
  }

  function fetchReview(handle, container) {
    if (handle in reviewCache) {
      if (reviewCache[handle]) renderReview(reviewCache[handle], container);
      return;
    }
    var url = REVIEW_API + encodeURIComponent(handle) +
              '?brandSlug=' + REVIEW_BRAND + '&sort=newest&limit=5';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var review = data && (data.reviews || []).find(function (r) {
          return r.rating >= 4 && r.reviewerDisplayName && r.reviewerDisplayName.trim();
        });
        reviewCache[handle] = review || null;
        if (review) renderReview(review, container);
      })
      .catch(function () { reviewCache[handle] = null; });
  }

  /* ---- init ---- */

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    if (!menus.length) return;

    function setOpen(details, open) {
      var summary = details.querySelector('summary');
      if (open && !details.open) {
        details.open = true;
        if (summary) summary.setAttribute('aria-expanded', 'true');
      } else if (!open && details.open) {
        details.open = false;
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }

    menus.forEach(function (menu) {
      var details  = menu.querySelector('details.mega-menu');
      if (!details) return;

      var closeTimer  = null;
      var reviewTimer = null;
      var reviewEl    = details.querySelector('.mega-menu__live-review');

      /* ---- mega menu open/close on hover ---- */
      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (other) {
          if (other !== details) setOpen(other, false);
        });
        setOpen(details, true);
      });

      menu.addEventListener('mouseleave', function () {
        window.clearTimeout(closeTimer);
        window.clearTimeout(reviewTimer);
        closeTimer = window.setTimeout(function () {
          if (!menu.contains(document.activeElement)) {
            setOpen(details, false);
            if (reviewEl) reviewEl.classList.remove('is-visible');
          }
        }, 220);
      });

      /* ---- live review on card hover ---- */
      if (!reviewEl) return;

      var cards = details.querySelectorAll('.mega-menu__card[data-product-handle]');
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          var handle = card.dataset.productHandle;
          if (!handle) return;
          window.clearTimeout(reviewTimer);
          if (reviewEl.dataset.handle === handle && reviewEl.classList.contains('is-visible')) return;
          reviewTimer = window.setTimeout(function () {
            reviewEl.dataset.handle = handle;
            fetchReview(handle, reviewEl);
          }, 2000);
        });

        card.addEventListener('mouseleave', function () {
          window.clearTimeout(reviewTimer);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
